/*
 * Fills in the cart delivery estimate ("Livrare vineri (18 sept.), comanda in
 * 3 h 29 min").
 *
 * This lives in an asset rather than inline in the snippet on purpose. The cart
 * drawer rebuilds its own markup when it opens and again on every cart change,
 * and a <script> that arrives inside replaced markup is never executed by the
 * browser. Inline, the bar came back empty - the right height, no words in it.
 * Loaded once from here, the code survives every rebuild and simply re-binds
 * whatever new element it finds.
 */
(function () {
  if (window.__kdDeliveryLine) return;
  window.__kdDeliveryLine = true;

  function parseYmd(v) {
    var p = (v || '').split('-');
    if (p.length !== 3) return null;
    // Built from parts the shop already resolved, so the visitor's timezone
    // cannot shift the day either way.
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }

  function setup(el) {
    if (!el || el.dataset.bound) return;
    var out = el.querySelector('[data-kd-del-text]');
    if (!out) return;

    var from = parseYmd(el.getAttribute('data-from'));
    if (!from) return;
    el.dataset.bound = '1';

    var to = parseYmd(el.getAttribute('data-to'));
    var locale = el.getAttribute('data-locale') || 'ro';
    var afterCutoff = el.getAttribute('data-after-cutoff') === 'true';
    var remaining = parseInt(el.getAttribute('data-seconds-left'), 10) || 0;

    function fmt(d, opts) {
      try {
        return d.toLocaleDateString(locale, opts);
      } catch (err) {
        return d.toLocaleDateString(undefined, opts);
      }
    }

    var isRange = !!(to && to.getTime() !== from.getTime());
    // A weekday beside a multi-day range contradicts itself ("Friday (4 - 7
    // Sep)"), so it only shows when the estimate lands on one day.
    var weekday = isRange ? '' : fmt(from, { weekday: 'long' });
    var dateText = fmt(from, { day: 'numeric', month: 'short' });
    if (isRange) dateText += ' – ' + fmt(to, { day: 'numeric', month: 'short' });

    function timeLeft() {
      var hrs = Math.floor(remaining / 3600);
      var mins = Math.floor((remaining % 3600) / 60);
      return hrs > 0 ? hrs + ' h ' + mins + ' min' : mins + ' min';
    }

    function render() {
      var tpl = el.getAttribute(afterCutoff || remaining <= 0 ? 'data-template-after' : 'data-template') || '';
      var html = tpl
        .split('{zi}').join(weekday ? '<span class="kd-del__day">' + weekday + '</span>' : '')
        .split('{data}').join('<span class="kd-del__day">' + dateText + '</span>')
        .split('{timp}').join('<span class="kd-del__left">' + timeLeft() + '</span>');
      // Tidy the gap and stray brackets left where the weekday was removed.
      html = html.replace(/\(\s*\)/g, '').replace(/\s{2,}/g, ' ').trim();
      out.innerHTML = html;
    }

    render();

    if (!afterCutoff && remaining > 0) {
      var timer = setInterval(function () {
        // A rebuilt drawer leaves the old element detached; its timer would
        // otherwise tick on for the life of the page.
        if (!el.isConnected) {
          clearInterval(timer);
          return;
        }
        remaining -= 60;
        if (remaining <= 0) {
          remaining = 0;
          afterCutoff = true;
          clearInterval(timer);
        }
        render();
      }, 60000);
    }
  }

  function scan() {
    var els = document.querySelectorAll('[data-kd-del]:not([data-bound])');
    for (var n = 0; n < els.length; n++) setup(els[n]);
  }

  function start() {
    scan();
    document.addEventListener('cart:updated', scan);

    try {
      var fox = window.FoxTheme;
      if (fox && fox.pubsub && fox.pubsub.PUB_SUB_EVENTS) {
        fox.pubsub.subscribe(fox.pubsub.PUB_SUB_EVENTS.cartUpdate, scan);
      }
    } catch (err) {
      // The theme's bus is a convenience here; the observer below is what the
      // fix actually rests on.
    }

    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          scan();
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
